module.exports = "/images/arrow-down.svg";